<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<title>Start Recording</title>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 15C10.343 15 9 13.657 9 12V6C9 4.343 10.343 3 12 3C13.657 3 15 4.343 15 6V12C15 13.657 13.657 15 12 15Z" fill="currentColor" />
<path d="M18 10V12C18 15.314 15.314 18 12 18V18C8.686 18 6 15.314 6 12V10" stroke="inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 18V21" stroke="inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.82001 21H16.18" stroke="inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
